/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Subtitle_File_DescInputs */

const en_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT, VTT, SCC, MCC formats`)
};

const fr_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats SRT, VTT, SCC, MCC`)
};

const de_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT-, VTT-, SCC- und MCC-Formate`)
};

const it_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formati SRT, VTT, SCC, MCC`)
};

const ru_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`форматы SRT, VTT, SCC, MCC`)
};

const es_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos SRT, VTT, SCC, MCC`)
};

const zh_cn2_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT、VTT、SCC、MCC 格式`)
};

const ja_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT、VTT、SCC、MCC 形式`)
};

const hi_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SRT, VTT, SCC, MCC प्रारूप`)
};

const pt_pt2_file_export_subtitle_file_desc = /** @type {(inputs: File_Export_Subtitle_File_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos SRT, VTT, SCC e MCC`)
};

/**
* | output |
* | --- |
* | "SRT, VTT, SCC, MCC formats" |
*
* @param {File_Export_Subtitle_File_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_subtitle_file_desc = /** @type {((inputs?: File_Export_Subtitle_File_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Subtitle_File_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_subtitle_file_desc(inputs)
	if (locale === "de") return de_file_export_subtitle_file_desc(inputs)
	if (locale === "it") return it_file_export_subtitle_file_desc(inputs)
	if (locale === "ru") return ru_file_export_subtitle_file_desc(inputs)
	if (locale === "es") return es_file_export_subtitle_file_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_subtitle_file_desc(inputs)
	if (locale === "ja") return ja_file_export_subtitle_file_desc(inputs)
	if (locale === "hi") return hi_file_export_subtitle_file_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_subtitle_file_desc(inputs)
	return en_file_export_subtitle_file_desc(inputs)
});